<template>
  <ul v-if="!isMobile" class="mx-10 grid grid-cols-2 gap-x-2.5 gap-y-5">
    <li
      v-for="card in props.links.slice(0, 4)"
      :key="card.url"
      class="flex cursor-pointer flex-col gap-2.5 text-left"
      role="link"
      @click="handleClick(card.url)"
    >
      <img
        :src="card.image_src"
        :alt="card.image_alt"
        class="aspect-8/10 size-full rounded-2xl object-cover"
      />
      <p class="line-clamp-2 h-12 px-1 text-xs/5 select-none" v-text="card.text" />
    </li>
  </ul>
  <div v-else ref="carouselContainer" class="absolute bottom-8 left-0 w-full">
    <div class="swiper">
      <div class="swiper-wrapper">
        <div
          v-for="slide in props.links"
          :key="slide.url"
          class="swiper-slide !flex cursor-pointer flex-col gap-2.5 text-left"
          role="link"
          @click="handleClick(slide.url)"
        >
          <img
            :src="slide.image_src"
            :alt="slide.image_alt"
            class="aspect-8/10 size-full rounded-2xl object-cover"
          />
          <p
            v-if="slide.text"
            class="line-clamp-2 h-10 px-1 text-xs/5 select-none"
            v-text="slide.text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from 'vue';

import { useViewportSize } from '../composables/use-viewport-size';
import { initSwiper } from '../utils/swiper';

const props = defineProps({
  handleClick: {
    default: () => () => {},
    type: Function,
  },
  links: {
    default: () => [],
    type: Array,
  },
});

const carouselContainer = ref(null);
let carousel = null;
const { isMobile } = useViewportSize();

const initCarousel = () => {
  if (!carouselContainer.value) return;

  carousel = initSwiper(carouselContainer.value, {
    slidesOffsetAfter: 18,
    slidesOffsetBefore: 18,
    slidesPerView: 2.4,
    spaceBetween: 10,
  });
};

const destroyCarousel = () => {
  carousel?.destroy();
  carousel = null;
};

onMounted(async () => {
  isMobile.value && initCarousel();
});

onUnmounted(() => {
  carousel && destroyCarousel();
});

watch(
  isMobile,
  () => {
    carousel && destroyCarousel();
    isMobile.value && initCarousel();
  },
  {
    flush: 'post',
  },
);
</script>
